function r(r) {
  return Array.isArray(r) ? r : [r];
}
function n(r) {
  return "function" == typeof r;
}
function t(r) {
  return "string" == typeof r;
}
function e(r) {
  return "number" == typeof r;
}
function u(r) {
  return !!r && "object" == typeof r && !Array.isArray(r);
}
function o(r) {
  return null == r;
}
function i(r) {
  return !o(r);
}
function c(r) {
  return r ? Array.isArray(r) || t(r) ? r.length : u(r) ? Object.keys(r).length : 0 : 0;
}
function f(r) {
  return 0 === c(r);
}
function a(r) {
  return r.replace(/(?:^\w|[A-Z]|\b\w)/g, (r, n) => 0 == n ? r.toLowerCase() : r.toUpperCase()).replace(/\s+|_|-|\//g, "");
}
function y(r) {
  return e(r) ? r : t(r) && !isNaN(Number(r) - parseFloat(r)) ? Number(r) : null;
}
export { r as coerceArray, i as isDefined, f as isEmpty, n as isFunction, o as isNil, e as isNumber, u as isObject, t as isString, c as size, a as toCamelCase, y as toNumber };